import React from 'react';
import OfferDetails from '../OfferDetails/OfferDetails';
import OfferHeader from '../OfferHeader/OfferHeader';
import OfferTicket from '../OfferTicket/OfferTicket';

const Offer = () => {
    return (
        <div>
            <OfferHeader/>
            <OfferDetails/>
            <OfferTicket/>
        </div>
    );
};

export default Offer;